import { declareString } from "@1js/localization";

export const ShareToastCopyLinkTitle = declareString(
  "promptLibrary.shareToastCopyLinkTitle",
  {
    text: "Link copied",
    comment: `Toast title that shows in a toast notification when the user clicks on the button to copy the prompt link to their clipboard. When the user pastes the link to a browser, the prompt page will be opened. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const ShareToastCopyLinkBody = declareString(
  "promptLibrary.shareToastCopyLinkBody",
  {
    text: "Anyone with this link will have access to the prompt. Link expires in 90 days.",
    comment: `Toast body that shows in a toast notification when the user clicks on the button to copy the prompt link to their clipboard. When the user pastes the link to a browser, the prompt page will be opened. 'prompts' is the text input provided to AI model like GPT.`,
  }
);

export const TryAgainLabel = declareString(
  "promptLibrary.shareToastTryAgainLabel",
  {
    text: "Try again",
    comment: `Toast message that shows in a toast notification when the copy the prompt link fails. When the user pastes the link to a browser, the prompt page will be opened. 'prompts' is the text input provided to AI model like GPT.`,
  }
);
